import { fetchRegions } from "services/regionsHelper";

const translateQuickUniversityLinks = async (region: any, userLanguage: string) => {
  const quickLinks = region?.quick_university_links;

  if (!userLanguage || userLanguage === "en" || !Array.isArray(quickLinks) || !quickLinks.length) {
    return;
  }

  const canonicalNames = quickLinks.map((link: any) => link?.canonical_name).filter(Boolean);
  if (canonicalNames.length === 0) return;

  const res: any = await fetchRegions({
    canonical_names: canonicalNames.join(","),
    lang: userLanguage,
    limit: canonicalNames.length,
  });

  const result = res?.data?.result;
  if (!Array.isArray(result) || result.length === 0) return;

  const translatedNameByCanonical = new Map<string, string>();
  result.forEach((university: any) => {
    if (university?.canonical_name && university?.name) {
      translatedNameByCanonical.set(university.canonical_name, university.name);
    }
  });

  region.quick_university_links = quickLinks.map((link: any) => {
    const translatedName = translatedNameByCanonical.get(link?.canonical_name);
    return translatedName && translatedName !== link.name
      ? { ...link, name: translatedName, name_en: link.name }
      : link;
  });
};

export default translateQuickUniversityLinks;
